export default {
  title:
    'https://mylink.oss-accelerate.aliyuncs.com/paradise/%E4%BB%BB%E5%8A%A1%E4%B8%AD%E5%BF%83%E4%B9%90%E5%9B%AD%20%E2%80%93%20%E5%85%B6%E4%BB%96%E6%83%85%E5%86%B5%E5%88%87%E5%9B%BE_slices/%E4%B8%BB%E6%A8%99%E9%A1%8C%402x%282%29.png',
  c1: 'My e-Cash Coupons',
  c2: 'Check in\n',
  c2_1: '\ndays this month',
  c3: 'Points Rules',
  c4: 'Activate Points',
  c5: 'Task Paradise',
  c5_1: ' ',
  c6: 'Point Records',
  c7: 'Check in now ',
  c8: 'Check in tomorrow ',
  c9: 'Go',
  c10: 'Completed',
  score109: 'Check in ',
  score109_1: ' days this month',
  score109_2: ' day',
  score110: 'Check-in 7 days for extra Points (once per month only)',
  score111: 'Remind me',
  score112: 'Check in reminder',
  score113:
    'After the switch is turned on, if the number of check-in times of this month is less than 3, the app will be pushed on the 15th and 20th of this month to remind you to check in. If closed, you will not be reminded.',
  score125: 'Checked in',
  score126: 'Double MyLink points',
  score127: 'sign in today',
  score128: 'You can get an extra gift  if you Check in for 7 days',
  score129: 'Check in now',
  score130: 'Check in Today',
  score131: '+',
  score131_2: ' Points',
  score155: 'Activate Points',
  score156: 'Points Records Details',
  score157: 'Point Rewards Code',
  score158: 'Authorization Code',
  score159: 'Send',
  score160: 'Activate Now',
  score161: 'MyLink Point Rewards Codes Terms and Conditions',
  score162:
    '1. The MyLink Point Rewards Codes are only applicable to the mobile-registered account of MyLink App (“MyLink") and do not apply to MyLink accounts registered with a home broadband number ("Eligible Users"). ',
  score163:
    '2. Eligible users can receive MyLink Point Rewards Codes through MyLink activities or other merchants’ activities. Eligible users can redeem MyLink Point Rewards Codes to MyLink Points at the MyLink App “MyLink Points” - “Active Points” within the validity period (the verification code will be sent to the number of the MyLink login account through SMS). Eligible users can check for details on MyLink "MyLink Points" - "Points Records Details".',
  score164:
    '3. Each MyLink Point Rewards Code can be used only once unless otherwise specified. EligibleUserscan find the valid redemption period of MyLink Point Rewards Codes at the MyLink Point Rewards Codes Terms and Conditions from the merchant. MyLink Point Rewards Codes must be redeemed to MyLink Points at the MyLink App within the designated validity period. The MyLink Point Rewards Codes shall be invalid after the designated expiry date. Expired MyLink Point Rewards Codes will not be reissued.',
  score165:
    '4. All MyLink Point Rewards Codes cannot be exchanged for cash, credit, or any other goods or services, and are non-replaceable, non-refundable, non-transferable, and non-resalable.',
  score166:
    '5. Valid Period of MyLink Points: MyLink Points redeemed between the period of 1 January and 30 June will be expired on 30 June in the following year, and MyLink Points redeemed between the period of 1 July and 31 December will be expired on 31 December in the following year. For MyLink Points Terms and Conditions, please check at ',
  score166_link:
    'https://eshop.hk.chinamobile.com/en/corporate_information/Mylink/mylinkpoints.html',
  score166_1:
    '6. Any third party to these Terms and Conditions shall not have any rights under the Cap. 623 Contracts (Rights of Third Parties) Ordinance of the laws of Hong Kong to enforce or enjoy the benefits or rights of any provision of these Terms and Conditions.',
  score166_2:
    '7. If the Court holds that any provision of these Terms and Conditions is invalid or unenforceable, the remaining provisions shall not be affected by such invalidity or unenforceability and shall have the force of law and effects.',
  score166_3:
    '8. Terms and Conditions herein are governed by the laws of the Hong Kong Special Administrative Region. Eligible Participants agree that any litigation or claim arising out of the Terms and Conditions shall be governed by the exclusive jurisdiction of the Hong Kong courts.',
  score166_4:
    '9. In case of any disputes, CMHK reserves the right to final decision.',
  score166_5:
    '10. If there is any discrepancy between the Chinese and English versions of these Terms and Conditions, the Chinese version shall prevail.',
  score167: 'Incorrect Point Rewards Code',
  score167_1: 'Expired Point Rewards Code',
  score167_2: 'Used Point Rewards Code',
  score167_3: 'Disused Point Rewards Code',
  score168: 'Incorrect Authorization Code',
  score169: 'points',
  score170: 'Go to Points Records for more details',
  score184: 'Cancel',
  score200: 'Notice',
  score201:
    'Your operation is too frequent or the point redemption amount is too high. Please try again later.',
  c11: 'Move the map, visit the paradise',
  c12: 'Pinch to zoom in and out, visit the paradise',
  c13: 'Next',
  c14: 'Understand',
  c15: 'You have shared it 3 times, next week come again~',
  c16: 'Swipe left and right, discover uncompleted tasks',
  c17: 'Network error, please try again',
  c18: 'You have checked in \ntoday',
  c19: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/%E6%B5%AE%E7%AA%97-%E7%B9%81%E4%BD%93%402x%20%282%29.png',
  c20: 'Task List ',
  c21: 'Click me to open blind box!',
  c22: 'Come again tomorrow ',
  c23: 'Blind Box Winning Records',
  c24: '"Sign in every day" changed to "lucky blind box daily reward"~',
  c25: 'Open the blind box to get a surprise',
  c26: 'Open Blind Box',
  c27: '"Daily Check-In" has been upgraded to "Lucky Blind Box Daily Rewards", open blind box now to get surprise!',
  c29: 'There are two more opportunities today',
  c30: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/9.3/sc%402x%281%29.png',
  c31: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/9.3/%E6%A0%87%E9%A2%98sc%402x2.png',
  c32: 'https://uatoss.mylinkapp.hk/via/atv/fan-model/index.html?lang=en#/home',
  c33: 'Finance',
  c34: 'Insurance',
  c35: 'Securities',
  c36: 'Remittance',
  c37: 'Shopping',
  c38: 'Go',
  c39: 'Completed',
  c40: 'Ended',
  c41:'Go',
  c42:'The rewards have been distributed today, come back tomorrow to take a look',
  c43:'The reward for the current task has been claimed. Please take a look at other tasks',
  c44:'Ok',
}
